import axios from "axios";

const getAddressByCEP = async (cep) => {
    // Remove qualquer caractere que não seja número
    const cepLimpo = cep.replace(/\D/g, '');
    if (cepLimpo.length !== 8) {
        throw new Error("CEP inválido.");
    }
    try {
        const response = await axios.get(`https://viacep.com.br/ws/${cepLimpo}/json/`);
        if (response.data.erro) {
            throw new Error("CEP não encontrado.");
        }
        return response.data;
    } catch (error) {
        console.error("Erro ao buscar CEP no serviço ViaCEP:", error);
        throw error;
    }
};

export const cepService = {
    getAddressByCEP,
};